const Import = require('../_import_' + process.env.NODE_ENV)
export default [
  {
    path: '/h5',
    component: Import('index/index'),
    name: 'index',
    meta: { title: '在线公证平台' },
    redirect: { name: 'indexIndex' }
  },
  {
    path: '/h5/index',
    component: Import('index/index'),
    name: 'indexIndex',
    meta: { title: '在线公证平台' }
  },
  {
    path: '/h5/about',
    component: Import('index/about'),
    name: 'about',
    meta: { title: '关于我们' }
  },
  {
    path: '/h5/contact',
    component: Import('index/contact'),
    name: 'contact',
    meta: { title: '联系我们' }
  },
  {
    path: '/h5/search',
    component: Import('index/search'),
    name: 'search',
    meta: { title: '搜索' }
  },
  {
    path: '/h5/weapp',
    component: Import('index/weapp'),
    name: 'weapp',
    meta: { title: '小程序' }
  }
]



// WEBPACK FOOTER //
// ./src/router/model/index.js